import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  FiHome, FiFolder, FiCheckSquare, FiClock,
  FiBarChart2, FiSettings, FiUsers, FiTarget, FiAlertCircle,
  FiDollarSign, FiCreditCard, FiFile, FiAlertTriangle, FiActivity, FiGrid, FiBriefcase, FiGitPullRequest, FiCalendar, FiUserCheck, FiTrendingUp, FiBookOpen, FiBriefcase as FiBuilding, FiCheckCircle, FiChevronDown, FiChevronRight, FiFileText, FiLayers, FiLink, FiPieChart, FiBarChart, FiGitMerge, FiAnchor, FiPackage, FiVideo, FiMessageSquare
} from 'react-icons/fi';
import { useAuth } from '../../contexts/AuthContext';
import { FaIndianRupeeSign } from 'react-icons/fa6';

const Sidebar = ({ isOpen ,selectedLogo }) => {
  const { user } = useAuth();

  const [expandedSections, setExpandedSections] = useState({
    dashboards: true,
    overview: true,
    portfolio: true,
    execution: true,
    governance: true,
    financial: true,
    vendors: true,
    collaboration: true,
    system: true
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  console.log("selectedLogo",selectedLogo)


  const menu = [
    {
      id: 'dashboards',
      title: 'Dashboards',
      roles: ["Super Admin","Admin", "Manager", "Member"],
      items: [
        { path: '/app/dashboard', icon: FiHome, label: 'Overview',roles: ["Super Admin","Admin", "Manager", "Member"] },
        { path: '/app/dashboard/executive', icon: FiTrendingUp, label: 'Executive',roles: ["Super Admin","Admin", "Manager", "Member"] },
        { path: '/app/dashboard/projects', icon: FiFolder, label: 'Projects',roles: ["Super Admin","Admin", "Manager", ] },
        { path: '/app/dashboard/team', icon: FiUsers, label: 'Members' ,roles: ["Super Admin","Admin", "Manager"]},
        { path: '/app/dashboard/financial', icon: FaIndianRupeeSign, label: 'Financial',roles: ["Super Admin","Admin", "Manager", ] },
      ]
    },
    {
      id: 'overview',
      title: 'Overview',
      items: [
        { path: '/app/activity-logs', icon: FiActivity, label: 'Activity' ,roles: ["Super Admin","Admin", "Manager"]},
        { path: '/app/reports', icon: FiBarChart2, label: 'Reports',roles: ["Super Admin","Admin", "Manager"] },
        { path: '/app/forecasts', icon: FiBarChart, label: 'Forecasts',roles: ["Super Admin","Admin", "Manager"] },
      ]
    },
    {
      id: 'portfolio',
      title: 'Portfolio Management',
      items: [
        { path: '/app/departments', icon: FiGrid, label: 'Departments' ,roles: ["Super Admin","Admin", "Manager"]},
        { path: '/app/portfolios', icon: FiBriefcase, label: 'Portfolios' ,roles: ["Super Admin","Admin", "Manager"]},
        { path: '/app/projects', icon: FiFolder, label: 'Projects' ,roles: ["Super Admin","Admin", "Manager"]},
      ]
    },
    {
      id: 'execution',
      title: 'Project Execution',
      items: [
        { path: '/app/tasks', icon: FiCheckSquare, label: 'Tasks' ,roles: ["Super Admin","Admin", "Manager", "Member"]},
        { path: '/app/squads', icon: FiUsers, label: 'Squads' ,roles: ["Super Admin","Admin", "Manager", "Member"]},
        { path: '/app/milestones', icon: FiTarget, label: 'Milestones' ,roles: ["Super Admin","Admin", "Manager", "Member"]},
        { path: '/app/dependencies', icon: FiGitMerge, label: 'Dependencies' ,roles: ["Super Admin","Admin", "Manager", "Member"]},
        { path: '/app/baselines', icon: FiAnchor, label: 'Baselines' ,roles: ["Super Admin","Admin", "Manager"]},
        { path: '/app/issues', icon: FiAlertCircle, label: 'Issues' ,roles: ["Super Admin","Admin", "Manager", "Member"]},
        { path: '/app/time-tracking', icon: FiClock, label: 'Time Tracking' ,roles: ["Super Admin","Admin", "Manager"]},
      ]
    },
    {
      id: 'governance',
      title: 'Governance & Quality',
      items: [
        { path: '/app/risks', icon: FiAlertTriangle, label: 'Risks' ,roles: ["Super Admin","Admin", "Manager"]},
        { path: '/app/change-requests', icon: FiGitPullRequest, label: 'Change Requests' ,roles: ["Super Admin","Admin", "Manager"]},
        { path: '/app/approvals', icon: FiCheckCircle, label: 'Approvals' ,roles: ["Super Admin","Admin", "Manager"]},
        { path: '/app/quality-metrics', icon: FiTrendingUp, label: 'Quality Metrics',roles: ["Super Admin","Admin", "Manager"] },
        { path: '/app/lessons-learned', icon: FiBookOpen, label: 'Lessons Learned' ,roles: ["Super Admin","Admin", "Manager"]},
      ]
    },
    {
      id: 'financial',
      title: 'Financial Management',
      items: [
        { path: '/app/budgets', icon: FaIndianRupeeSign, label: 'Budgets' ,roles: ["Super Admin","Admin", "Manager"]},
        { path: '/app/expenses', icon: FiCreditCard, label: 'Expenses' ,roles: ["Super Admin","Admin", "Manager"]},
      ]
    },
    {
      id: 'vendors',
      title: 'Client Management',
      items: [
        { path: '/app/vendors', icon: FiPackage, label: 'Clients' ,roles: ["Super Admin","Admin", "Manager"] },
        { path: '/app/vendors/create', icon: FiUserCheck, label: 'Onboard Client' ,roles: ["Super Admin","Admin", "Manager"] },
        { path: '/app/contracts', icon: FiFile, label: 'Contracts' ,roles: ["Super Admin","Admin", "Manager"] },
        // { path: '/app/vendors/contracts', icon: FiFile, label: 'Contracts',roles: ["Super Admin","Admin", "Manager", "Member"] },
      ]
    },
    {
      id: 'collaboration',
      title: 'Collaboration',
      items: [
        // { path: '/app/chat', icon: FiMessageSquare, label: 'Chat',roles: ["Super Admin","Admin", "Manager", "Member"]},
        { path: '/app/meetings', icon: FiCalendar, label: 'Meetings' ,roles: ["Super Admin","Admin", "Manager"]},
        { path: '/app/stakeholders', icon: FiUserCheck, label: 'Stakeholders' ,roles: ["Super Admin","Admin", "Manager"]},
        { path: '/app/resources', icon: FiUsers, label: 'Resources' ,roles: ["Super Admin","Admin", "Manager"]},
        { path: '/app/documents', icon: FiFile, label: 'Documents' ,roles: ["Super Admin","Admin", "Manager"]},
        { path: '/app/templates', icon: FiLayers, label: 'Templates' ,roles: ["Super Admin","Admin", "Manager"]},
      ]
    },
    {
      id: 'system',
      title: 'System',
      items: [
        // { path: '/app/demo-requests', icon: FiVideo, label: 'Demo Requests' },
        { path: '/app/integrations', icon: FiLink, label: 'Integrations' ,roles: ["Super Admin","Admin", "Manager", "Member"]},
        { path: '/app/audit-logs', icon: FiFileText, label: 'Audit Logs' ,roles: ["Super Admin","Admin", "Manager"]},
        { path: '/app/settings', icon: FiSettings, label: 'Settings' ,roles: ["Super Admin","Admin", "Manager", "Member"]},
        { path: '/app/settings/roles', icon: FiBriefcase, label: 'Roles' ,roles: ["Super Admin","Admin", "Manager"]},
      ]
    }
  ];

  console.log("user?.role?.name", user?.role?.name);
  const userRoles = [user?.role?.name];
  const menuSections = menu
  .map(section => ({
    ...section,
    items: section.items.filter(item =>
      item.roles?.some(role => userRoles.includes(role))
    )
  }))
  .filter(section => section.items.length);


  return (
    <aside className={`bg-gray-800 text-white w-64 absolute inset-y-0 left-0 transform ${isOpen ? 'translate-x-0' : '-translate-x-full'} md:relative md:translate-x-0 transition duration-200 ease-in-out flex flex-col`}>
      {/* Company/Organization Header */}
      <div className="px-4 py-6 flex-shrink-0 border-b border-gray-700">
        <div className="flex items-center space-x-3">
          {/* Company Avatar */}
          {/* <div className="flex-shrink-0">
            {user?.organization?.logo_url ? (
              <img
                src={user.organization.logo_url}
                alt={user.organization?.name || 'Organization'}
                className="w-12 h-12 rounded-lg object-cover ring-2 ring-blue-500"
              />
            ) : (
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center ring-2 ring-blue-500 shadow-lg">
                <FiBuilding className="w-6 h-6 text-white" />
              </div>
            )}
          </div> */}

          <div className="flex-shrink-0">
            {user?.organization?.logo_url ? (
              <img
                src={user.organization.logo_url}
                alt={user?.organization?.name || "Organization"}
                className="w-12 h-12 rounded-lg object-cover ring-2 ring-blue-500"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.nextSibling.style.display = "flex";
                }}
              />
            ) : null}

            <div
              className={`w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 items-center justify-center ring-2 ring-blue-500 shadow-lg text-white font-semibold text-lg ${user?.organization?.logo_url ? "hidden" : "flex"
                }`}
            >
              {user?.organization?.name?.charAt(0)?.toUpperCase() || "O"}
            </div>
          </div>

          {/* Company Info */}
          <div className="flex-1 min-w-0">
            <h2 className="text-sm font-bold text-white truncate">
              {user?.organization?.name || 'Project Portfolio'}
            </h2>
            <p className="text-xs text-gray-400 truncate">
              {user?.organization?.industry || 'Management System'}
            </p>
          </div>
        </div>
      </div>

      {/* User Info Section */}
      <div className="px-4 py-3 flex-shrink-0 bg-gray-750">
        {/* <div className="flex items-center space-x-2">
          <div className="w-8 h-8 rounded-full bg-gradient-to-br from-green-400 to-blue-500 flex items-center justify-center text-white text-sm font-semibold">
            {user?.first_name?.[0]}{user?.last_name?.[0]}
          </div>
          <div className="flex-shrink-0" >
          {user?.avatar_url ? (
            <img
              src={user.avatar_url}
              alt={user?.first_name || "Organization"}
              className="w-12 h-12 rounded-lg object-cover ring-2 ring-blue-500"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "flex";
              }}
              style={{'border-radius': "50%"}}
            />
          ) : null}

          <div
            className={`w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500 to-purple-600 items-center justify-center ring-2 ring-blue-500 shadow-lg text-white font-semibold text-lg ${user?.organization?.logo_url ? "hidden" : "flex"
              }`}
          >
            {user?.organization?.name?.charAt(0)?.toUpperCase() || "O"}
          </div>
        </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-white truncate">
              {user?.first_name} {user?.last_name}
            </p>
            <p className="text-xs text-gray-400 truncate">
              {user?.role?.name || 'User'}
            </p>
          </div>
        </div> */}


        
  
      </div>
      <nav className="flex-1 overflow-y-auto px-2 pb-4 pt-2">
        {menuSections.map((section) => (
          <div key={section.id} className="mb-2">
            {/* Section Header */}
            <button
              onClick={() => toggleSection(section.id)}
              className="w-full flex items-center justify-between px-3 py-2 text-xs font-semibold text-gray-400 uppercase tracking-wider hover:text-gray-300 transition-colors"
            >
              <span>{section.title}</span>
              {expandedSections[section.id] ? (
                <FiChevronDown className="w-4 h-4" />
              ) : (
                <FiChevronRight className="w-4 h-4" />
              )}
            </button>

            {/* Section Items */}
            {expandedSections[section.id] && (
              <div className="space-y-1">
                {section.items.map((item) => (
                  <NavLink
                    key={item.path}
                    to={item.path}
                    className={({ isActive }) =>
                      `flex items-center space-x-2 py-2 px-4 rounded transition duration-200 ${isActive ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white'
                      }`
                    }
                  >
                    <item.icon className="w-4 h-4 flex-shrink-0" />
                    <span className="text-sm">{item.label}</span>
                  </NavLink>
                ))}
              </div>
            )}
          </div>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
